import Vue from 'vue'

/*
 * Main App Component
 */
import App from './App.vue'
Vue.component('app', App)

/*
 * Layout Components
 */
import offCanvas from './components/layout/SidebarOffCanvas.vue'
Vue.component('off-canvas', offCanvas)
Vue.use(offCanvas)

/*
 * Google Maps
 */
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
Vue.component('google-map', VueGoogleMaps.Map)
Vue.component('google-marker', VueGoogleMaps.Marker)
Vue.component('google-cluster', GmapCluster)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAKrw_Rlux-ql-mPW6Wdg_jQl9FaIs2moc',
    libraries: 'places,geometry'
  }
})

/*
 * Gas Station Finder Components
 */
import gasStationFinder from './components/gasStationFinder/gasStationFinder.vue'
Vue.component('gas-station-finder', gasStationFinder)
import stationFilterSidebar from './components/gasStationFinder/stationFilterSidebar.vue'
Vue.component('station-filter-sidebar', stationFilterSidebar)
import stationMap from './components/gasStationFinder/stationMap.vue'
Vue.component('station-map', stationMap)
import stationDetail from './components/gasStationFinder/stationDetail.vue'
Vue.component('station-detail', stationDetail)
import routePanel from './components/gasStationFinder/routePanel.vue'
Vue.component('route-panel', routePanel)
import gasStationSearch from './components/searchWidget/SearchWidget.vue'
Vue.component('gas-station-search', gasStationSearch)



// WEBPACK FOOTER //
// ./Resources/Private/JavaScript/components.js